import type { PaginationState } from '../../hooks/DataTable/types';

/**
 * query를 PaginationState로 변환한다.
 * query에는 pageIndex만 넣어준다.
 * @param query
 * @param defaultValue
 * @param pageSize
 */
export function convertQueryToPaginationState(
  query: Record<string, unknown> | undefined,
  defaultValue: number,
  pageSize: number,
): PaginationState {
  return {
    pageIndex: Number(query?.page ?? defaultValue) || 1,
    pageSize: pageSize ?? 20,
  };
}

/**
 * PaginationState를 query로 변환한다.
 * query에는 pageIndex만 넣어준다.
 * query 생성을 의도하므로, 데이터는 항상 string/string[]로 변환한다.
 * @param state
 */

export function convertPaginationToQueryState(state: Partial<PaginationState>) {
  return {
    page: `${state.pageIndex ?? 1}`,
  };
}
